import { useNavigate } from 'react-router-dom'

interface HashLinkProps {
  to: string
  children: React.ReactNode
}

export const HashLink = ({ to, children }: HashLinkProps) => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    
    if (to.startsWith('/#')) {
      const hash = to.substring(2)
      navigate('/')
      setTimeout(() => {
        const element = document.getElementById(hash)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    } else {
      navigate(to)
    }
  }

  return (
    <a href={to} onClick={handleClick} style={{ cursor: 'pointer' }}>
      {children}
    </a>
  )
}
